import { Component, Input, Output, EventEmitter, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-generic-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule,ReactiveFormsModule],
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.css']
})
export class GenericDialogComponent {
  @Input() visible: boolean = false;
  @Input() dialogTitle: string = '';
  @Input() imageSrc: string = '';
  @Input() formGroup: FormGroup | undefined;
  @Input() submitButtonLabel: string = 'Salvar';
  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onCancel(): void {
    this.cancel.emit();
  }

  onDialogClose() {
    this.cancel.emit();
  }
}
